import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { DialogDescription } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { isHotkey } from 'is-hotkey';
import { getDefaultRadixPortalContainer } from '@fabric-app/compat';
import { isInteractiveElement } from '@fabric-app/utils/element';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';
import { Kbd } from '@fabric-app/ui/components/Kbd';
import { P } from '@fabric-app/ui/components/Typography';
import { IconEnter } from '@fabric-app/icons/old';

const ConfirmDisplay = ({ alert }) => {
  const onConfirmEnter = (e) => {
    if (!isHotkey("enter", e) || isInteractiveElement(e.target)) return;
    e.preventDefault();
    alert.onConfirm();
  };
  const contentProps = {
    onKeyDown: onConfirmEnter,
    onOpenAutoFocus: () => {
      return true;
    }
  };
  const buttons = /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsxs(Modal.Button, {
        ...alert.confirmButtonProps,
        onClick: alert.onConfirm,
        tabIndex: 1,
        style: {
          order: 10
        },
        children: [
          alert.confirmLabel,
          " ",
          /* @__PURE__ */ jsx(Kbd, {
            children: /* @__PURE__ */ jsx(IconEnter, {})
          })
        ]
      }),
      /* @__PURE__ */ jsxs(Modal.CancelButton, {
        onClick: alert.onCancel,
        tabIndex: 1,
        children: [
          alert.cancelLabel,
          " ",
          /* @__PURE__ */ jsx(Kbd, {
            children: "ESC"
          })
        ]
      })
    ]
  });
  return alert.fullScreen ? /* @__PURE__ */ jsx(Modal.Root, {
    open: true,
    onOpenChange: alert.onCancel,
    children: /* @__PURE__ */ jsx(Modal.Portal, {
      container: getDefaultRadixPortalContainer(),
      children: /* @__PURE__ */ jsxs(Modal.Content, {
        width: "full",
        height: "full",
        dynamicHeight: false,
        ...contentProps,
        children: [
          /* @__PURE__ */ jsx(Modal.Header, {
            padding: "sm",
            variant: "default",
            mobileOnly: true,
            children: alert.title
          }),
          /* @__PURE__ */ jsx(VisuallyHidden, {
            children: /* @__PURE__ */ jsx(DialogDescription, {
              children: alert.content
            })
          }),
          /* @__PURE__ */ jsx(Modal.Body, {
            padding: "sm",
            children: alert.content
          }),
          /* @__PURE__ */ jsx(Modal.Footer, {
            gap: "lg",
            variant: "fullscreen",
            children: buttons
          })
        ]
      })
    })
  }) : /* @__PURE__ */ jsx(Modal.Root, {
    open: true,
    onOpenChange: alert.onCancel,
    children: /* @__PURE__ */ jsxs(Modal.Portal, {
      container: getDefaultRadixPortalContainer(),
      children: [
        /* @__PURE__ */ jsx(Modal.Overlay, {
          visibleOnMobileViewport: true
        }),
        /* @__PURE__ */ jsx(Modal.Content, {
          width: "xs",
          disableMobileFullscreen: true,
          ...contentProps,
          children: /* @__PURE__ */ jsxs(Modal.Body, {
            padding: "sm",
            style: {
              gap: 20
            },
            children: [
              /* @__PURE__ */ jsx(Modal.Title, {
                size: "xs",
                style: {
                  marginTop: ".125rem"
                },
                children: alert.title
              }),
              /* @__PURE__ */ jsx(VisuallyHidden, {
                children: /* @__PURE__ */ jsx(DialogDescription, {
                  children: alert.content
                })
              }),
              /* @__PURE__ */ jsx(P, {
                size: "md",
                children: alert.content
              }),
              /* @__PURE__ */ jsx(Modal.DoubleButtonContainer, {
                children: buttons
              })
            ]
          })
        })
      ]
    })
  });
};

export { ConfirmDisplay as default };
//# sourceMappingURL=ConfirmDisplay.js.map
